import { cloneElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, Tooltip, usePopoverContext } from '@bonusly/design-system';

import { useReactionTypes } from './hooks/use-reaction-types';
import { useTrackReaction } from './hooks/use-track-reaction';
import { useReactionContext } from './reaction-select-context';
import { ReactionType } from './types';

export const ReactionMenu = () => {
	const { t } = useTranslation('recognition');
	const { onClose } = usePopoverContext();
	const reactionTypes = useReactionTypes();
	const { createReaction, removeReaction, replaceReaction, selected } = useReactionContext();

	const track = useTrackReaction();

	const handleClickSelect = (type: ReactionType) => {
		onClose();

		if (!selected) {
			track.create(type);
			createReaction(type);
		} else if (selected.type === type) {
			track.remove(type);
			removeReaction(selected);
		} else {
			track.replace(type);
			replaceReaction({ from: selected, to: type });
		}
	};

	return (
		<Flex columnGap={2} p={2}>
			{reactionTypes.map((reaction) => {
				return (
					<Tooltip label={t(`reactions.name.${reaction.type}`)} key={reaction.type} gutter={14} placement="top">
						<Box
							as="button"
							aria-label={t(`reactions.name.${reaction.type}`) ?? ''}
							onClick={() => handleClickSelect(reaction.type)}
							_hover={{
								'> div': {
									transform: 'scale(1.27)',
								},
							}}
						>
							<Box transitionDuration="normal" transitionProperty="transform">
								{cloneElement(<reaction.icon />, { h: 9, w: 9 })}
							</Box>
						</Box>
					</Tooltip>
				);
			})}
		</Flex>
	);
};
